import { Button, Row, Col } from 'react-bootstrap';
import { ITripStats } from '../utils/calculation.utils';
import { formatMoneyDisplay } from '../../common/money-input';

interface TripStatsCardsProps {
    tripStats: ITripStats;
    viewType: 'trip' | 'overall';
    allTripsApproved: boolean;
    onViewTypeChange: (viewType: 'trip' | 'overall') => void;
}

export const TripStatsCards = (props: TripStatsCardsProps) => {
    return (
        <div style={{ background: 'white', borderRadius: '6px', padding: '16px', marginBottom: '16px', border: '1px solid #e1e8ed', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            {props.allTripsApproved && (
                <div style={{ display: 'flex', gap: '0px', marginBottom: '16px', borderBottom: '1px solid #e1e8ed', paddingBottom: '12px' }}>
                    <Button 
                        bsSize="sm" 
                        bsStyle="default" 
                        onClick={() => props.onViewTypeChange('trip')}
                        style={{ 
                            fontSize: '13px', 
                            padding: '8px 16px', 
                            backgroundColor: props.viewType === 'trip' ? '#6c757d' : '#f8f9fa', 
                            borderColor: props.viewType === 'trip' ? '#6c757d' : '#dee2e6', 
                            color: props.viewType === 'trip' ? 'white' : '#6c757d',
                            borderRadius: '4px 4px 0 0',
                            borderBottom: 'none',
                            fontWeight: props.viewType === 'trip' ? 600 : 500
                        }} 
                    >
                        Trip View
                    </Button>
                    <Button 
                        bsSize="sm" 
                        bsStyle="default" 
                        onClick={() => props.onViewTypeChange('overall')}
                        style={{ 
                            fontSize: '13px', 
                            padding: '8px 16px', 
                            backgroundColor: props.viewType === 'overall' ? '#6c757d' : '#f8f9fa', 
                            borderColor: props.viewType === 'overall' ? '#6c757d' : '#dee2e6', 
                            color: props.viewType === 'overall' ? 'white' : '#6c757d',
                            borderRadius: '4px 4px 0 0',
                            borderBottom: 'none',
                            fontWeight: props.viewType === 'overall' ? 600 : 500
                        }}
                    >
                        Overall View
                    </Button>
                </div>
            )}
            <Row>
                <Col md={3} xs={6}>
                    <div style={{ textAlign: 'center', padding: '12px 8px' }}>
                        <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: 600, textTransform: 'uppercase', marginBottom: '6px', letterSpacing: '0.5px' }}>PREVIOUSLY REIMBURSED</div>
                        <div style={{ fontSize: '18px', fontWeight: 700, color: '#0d6efd' }}>{formatMoneyDisplay(props.tripStats.previousReimbursementAmount)}</div>
                    </div>
                </Col>
                <Col md={3} xs={6}>
                    <div style={{ textAlign: 'center', padding: '12px 8px' }}>
                        <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: 600, textTransform: 'uppercase', marginBottom: '6px', letterSpacing: '0.5px' }}>PENDING REIMBURSEMENT</div>
                        <div style={{ fontSize: '18px', fontWeight: 700, color: '#6c757d' }}>{formatMoneyDisplay(props.tripStats.currentlyApproved)}</div>
                    </div>
                </Col>
                <Col md={3} xs={6}>
                    <div style={{ textAlign: 'center', padding: '12px 8px' }}>
                        <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: 600, textTransform: 'uppercase', marginBottom: '6px', letterSpacing: '0.5px' }}>PENDING APPROVAL(S)</div>
                        <div style={{ fontSize: '18px', fontWeight: 700, color: '#fd7e14' }}>{formatMoneyDisplay(props.tripStats.currentPendingReimbursementAmount)}</div>
                    </div>
                </Col>
                <Col md={3} xs={6}>
                    <div style={{ textAlign: 'center', padding: '12px 8px' }}>
                        <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: 600, textTransform: 'uppercase', marginBottom: '6px', letterSpacing: '0.5px' }}>REMAINING DER LIMIT</div>
                        <div style={{ fontSize: '18px', fontWeight: 700, color: '#198754' }}>{formatMoneyDisplay(props.tripStats.derLimit > 0 ? props.tripStats.derLimit : 0)}</div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

